import React from "react";
import { band, BAND_META } from "@/lib/riskBand";

// 3-band risk chip (Master-Prompt Stage B): text / bg / 1px border, 7px dot, 12.5px/600.
// Pass `score` (preferred) or an explicit `bandKey`.
export const RiskChip = ({ score, bandKey, className = "", testid }) => {
  const key = bandKey || band(score) || "no_data";
  const m = BAND_META[key] || BAND_META.no_data;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[12.5px] font-semibold border ${className}`}
      style={{ color: m.text, backgroundColor: m.bg, borderColor: m.line }}
    >
      <span className="h-[7px] w-[7px] rounded-full" style={{ backgroundColor: m.bar }} />
      {m.label}
    </span>
  );
};

export default RiskChip;
